import { FormControl, Input as MuiInput, Typography } from '@material-ui/core';
import { InputProps as MuiInputProps } from '@material-ui/core/Input';
import classNames from 'classnames';
import React, { FC, memo } from 'react';

import useStyles from './styles';

export interface InputBaseProps {
  centered: boolean;
  error: string | boolean;
  hideErrorMessage: boolean;
  label: string;
  rootClass: string;
  size: 'small' | 'large' | number;
  variant: 'filled' | 'outlined' | 'standard';
  required?: boolean;
}
export type InputProps = Partial<InputBaseProps> & MuiInputProps;

export const Input: FC<InputProps> = ({
  label,
  error,
  centered,
  rootClass,
  hideErrorMessage,
  size = 'large',
  variant,
  required,
  ...props
}) => {
  const styles = useStyles({ size, variant });

  return (
    <FormControl
      classes={{
        root: styles.formControl,
      }}
      className={rootClass}
      hiddenLabel={!label}
    >
      {label && (
        <Typography classes={{ root: classNames(styles.label, { required }) }} color="textSecondary" variant="body2">
          {label}
        </Typography>
      )}
      <MuiInput
        classes={{
          focused: styles.focused,
          input: classNames(styles.input, { centered }),
          root: classNames(styles.root, { error, [styles.multiline]: props.multiline }),
        }}
        disableUnderline
        {...props}
      />
      {error && !hideErrorMessage && (
        <Typography align="right" classes={{ root: styles.errorMessage }} color="error" variant="caption">
          {error}
        </Typography>
      )}
    </FormControl>
  );
};

export default memo(Input);
